import React from 'react';
import { Routes, Route, Navigate, NavLink, useLocation } from 'react-router-dom';
import SalesOrderReport from './SalesOrderReport.jsx';
import InventoryReport from './InventoryReport.jsx';
import AdminOrderArchive from './AdminOrderArchive.jsx';
import CustomerDataReport from './CustomerDataReport.jsx';
import './AdminReports.css';

function AdminReports() {
    const location = useLocation();

    const tabs = [
        { to: '/admin/reports/sales', label: 'Sales & Order Report' },
        { to: '/admin/reports/inventory', label: 'Inventory Report' },
        { to: '/admin/reports/customers', label: 'Customer Registry' },
        { to: '/admin/reports/order-archive', label: 'Order Archive' },

    ];

    return (
        <div className="admin-reports-wrapper">
            <div className="admin-reports-tabs">
                {tabs.map((tab) => (
                    <NavLink
                        key={tab.to}
                        to={tab.to}
                        className={({ isActive }) =>
                            `admin-reports-tab${isActive ? ' is-active' : ''}`
                        }
                    >
                        {tab.label}
                    </NavLink>
                ))}
            </div>
            <div className="admin-reports-content">
                <Routes>
                    <Route index element={<Navigate to="sales" replace />} />
                    <Route path="sales" element={<SalesOrderReport />} />
                    <Route path="inventory" element={<InventoryReport />} />
                    <Route path="customers" element={<CustomerDataReport />} />
                    <Route path="order-archive" element={<AdminOrderArchive />} />
                </Routes>
            </div>
        </div>
    );
}

export default AdminReports;